<template>
    <v-main>
        <v-container fluid>
            <v-card elevation="6">
                <v-card-title class="mt-4">
                    <v-btn class="mr-2" fab x-small color="primary" @click="$router.back()">
                        <v-icon dark> mdi-arrow-left </v-icon> </v-btn>Add a Admin
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col sm="4">
                            <v-text-field v-model="form.name" outlined label="First Name *" prepend-inner-icon="mdi-buffet"
                                :error-messages="errors.name"></v-text-field>
                        </v-col>
                        <v-col sm="4">
                            <v-text-field v-model="form.middle_name" outlined label="Middle Name *"
                                prepend-inner-icon="mdi-buffet" :error-messages="errors.middle_name"></v-text-field>
                        </v-col>
                        <v-col sm="4">
                            <v-text-field v-model="form.last_name" outlined label="Last Name *"
                                prepend-inner-icon="mdi-buffet" :error-messages="errors.last_name"></v-text-field>
                        </v-col>
                        <v-col sm="4">
                            <v-text-field v-model="form.phone" outlined label="Mobile no *" prepend-inner-icon="mdi-phone"
                                :error-messages="errors.phone"></v-text-field>
                        </v-col>
                        <v-col sm="4">
                            <v-text-field v-model="form.email" outlined label="Email *" prepend-inner-icon="mdi-email"
                                :error-messages="errors.email"></v-text-field>
                        </v-col>
                        <v-col sm="4">
                            <v-autocomplete outlined ref="rank" v-model="form.rank" :items="ranks" label="Rank *"
                                append-icon="mdi-account" :error-messages="errors.rank"></v-autocomplete>
                        </v-col>
                        <v-col sm="4">
                            <v-select outlined ref="role" v-model="form.role_id" :items="roleItems" item-text="text"
                                item-value="value" label="Role *" prepend-inner-icon="mdi-shield-account"
                                :error-messages="errors.role_id"></v-select>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-5 mb-5"> </v-divider>

                    <v-progress-circular v-if="isLoading" indeterminate color="primary"></v-progress-circular>
                    <v-btn v-else color="primary" dark @click="save"> Save Admin </v-btn>
                </v-card-text>
            </v-card>
        </v-container>
    </v-main>
</template>
<script>
import axios from "axios";
export default {
    name: "AdminCreate",
    data() {
        return {
            form: {
                active: true,
                rank: "", // Add rank field
                role_id: 2, // Default to ADMIN; can be switched to MANAGER
            },
            isLoading: false,
            ranks: [], // Add ranks array
            roleItems: [
                { text: "ADMIN", value: 2 },
                { text: "MANAGER", value: 6 },
            ],
        };
    },
    mounted() {
        this.getMasters(); // Load master data including ranks
        console.log(this.companyId);
    },
    methods: {
        async getMasters() {
            try {
                let response = await axios.get(`users/masters`);
                let masters = response.data?.data || response.data || {};

                // Handle ranks data
                if (masters.ranks && Array.isArray(masters.ranks)) {
                    this.ranks = masters.ranks.map(rank => ({
                        text: rank.description,
                        value: rank.description,
                    }));
                }

                console.log('Admin create: Masters data loaded - Ranks:', this.ranks.length);
            } catch (error) {
                console.error('Admin create: Error loading masters data:', error);
                this.ranks = [];
            }
        },

        async save() {
            try {
                this.isLoading = true;
                this.form.role_id = this.form.role_id || 2;
                await axios.post("/users", this.form);
                this.isLoading = false;
                this.$router.push("/admin");
            } catch (e) {
                // alert("error");
                this.isLoading = false;
            }
        },
    },
};
</script>
  